import { render, staticRenderFns } from "./pship-columns-slider.component.vue?vue&type=template&id=4f5fd70d&"
import script from "./pship-columns-slider.component.vue?vue&type=script&lang=ts&"
export * from "./pship-columns-slider.component.vue?vue&type=script&lang=ts&"
import style0 from "./pship-columns-slider.component.vue?vue&type=style&index=0&id=4f5fd70d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports